import { ChangeEvent, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { State } from "../../../../reducer";
import { OrderSummaryBar } from "./orderSumaryBar";
import { OrderSaucePicker, useOrderSauce } from "../../../../components/OrderSaucePicker";

export const FormOrderBar = () => {
  const [showModal, setShowModal] = useState(false);
  const handleOnClose = () => setShowModal(false);

  const user = useSelector((state: State) => state.user);
  const order = useSelector((state: State) => state.order);
  const { menuName, menuID, description } = useParams();
  const menuIdAsNumber = menuID ? parseInt(menuID) : order.menu_id;
  const dispatch = useDispatch();

  const [inputValueAddition, setInputValueAddition] = useState<string>("");
  const { sauces, sauce, setSauce, valid: sauceValid, remark, previousNote } = useOrderSauce(
    menuIdAsNumber, order.menu_id === menuIdAsNumber ? order.remark : ""
  );
  // Reorders retain the original shot, sauce and free-text note.
  useEffect(() => { if (previousNote) setInputValueAddition(previousNote); }, [previousNote]);
  useEffect(() => {
    if (order.menu_id === menuIdAsNumber && order.type) {
      setSelectedType(order.type);
      setIsSelectedType(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleInputChangeAddition = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValueAddition(event.target.value);
  };

  const [isSelectedType, setIsSelectedType] = useState(false);
  const [selectedType, setSelectedType] = useState<string>("");
  const handleRadioChangeType = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedType(event.target.value);
    setIsSelectedType(true);
  };

  const isFormValid = isSelectedType && sauceValid;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isFormValid) {
      dispatch({ type: "SETMENU", payload: {
        menu_id: menuIdAsNumber,
        menu_name: menuName,
        type: selectedType,
        sweetness: 0,
        remark: remark(inputValueAddition),
        tumblerImage: description,
      }});
      setShowModal(true);
    } else {
      alert("please check your order");
    }
  };

  const handleCancel = () => {
    dispatch({
      type: "CLEAR",
    });
    console.clear();
  };

  return (
    <div className="h-screen font-nunito overflow-hidden ">
      <div className="flex justify-between items-center">
        {user.role === "admin" && (
          <Link to="../menubar-admin">
            <button className="ml-20" onClick={handleCancel}>
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99953 0.704609C6.60953 0.314609 5.97953 0.314609 5.58953 0.704609L0.999531 5.29461C0.609531 5.68461 0.609531 6.31461 0.999531 6.70461L5.58953 11.2946C5.97953 11.6846 6.60953 11.6846 6.99953 11.2946C7.38953 10.9046 7.38953 10.2746 6.99953 9.88461L3.11953 5.99461L6.99953 2.11461C7.38953 1.72461 7.37953 1.08461 6.99953 0.704609Z"
                  fill="black"
                />
              </svg>
            </button>
          </Link>
        )}
        {user.role === "user" && (
          <Link to="../menubar">
            <button className="ml-20" onClick={handleCancel}>
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99953 0.704609C6.60953 0.314609 5.97953 0.314609 5.58953 0.704609L0.999531 5.29461C0.609531 5.68461 0.609531 6.31461 0.999531 6.70461L5.58953 11.2946C5.97953 11.6846 6.60953 11.6846 6.99953 11.2946C7.38953 10.9046 7.38953 10.2746 6.99953 9.88461L3.11953 5.99461L6.99953 2.11461C7.38953 1.72461 7.37953 1.08461 6.99953 0.704609Z"
                  fill="black"
                />
              </svg>
            </button>
          </Link>
        )}

        <div className="py-2 pr-32 text-16 text-primary-onligth font-semibold text-center mx-auto"
        style={{
          wordBreak: "break-word",
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "80%",
        }}
        >
          {menuName}
        </div>
      </div>
      <hr className="h-px bg-gray-200 border-0"></hr>

      <form
        className="Content mx-20 pt-16 pb-48 flex flex-col h-screen justify-between"
        onSubmit={handleSubmit}
      >
        <div className=" ">
          <div className="pt-2 flex flex-col">
            <span className="text-sm font-semibold text-primary-onligth">
              Description
            </span>
            <span className="text-sm text-secondary-S600 pt-8"
            style={{ wordBreak: "break-word" }}
            >
              {description}
            </span>
          </div>
          <div className="flex items-center pt-16">
            <span className="text-sm text-primary-onligth font-semibold">
              Shot
            </span>
            <span
              className={`text-12 font-poppins align-bottom px-1  ${
                isSelectedType ? "text-secondary-S700" : "text-red-R200"
              } `}
            >
              (Require)
            </span>
          </div>
          <div className="flex flex-wrap">
            <label className="text-sm  text-secondary-S600">
              <div className="flex items-center w-72 max-w-xl pt-8 pb-4 bg-white gap-3">
                <input
                  type="radio"
                  required
                  value="extra-shot"
                  checked={selectedType === "extra-shot"}
                  onChange={handleRadioChangeType}
                  className="h-16 w-16 text-blue-600 bg-gray-100 border-gray-300  "
                />{" "}
                Extra Shot
              </div>
            </label>
          </div>
          <div className="flex flex-wrap">
            <label className="text-sm  text-secondary-S600">
              <div className="flex items-center w-72 max-w-xl pt-4 bg-white gap-3">
                <input
                  type="radio"
                  required
                  value="reduce-shot"
                  checked={selectedType === "reduce-shot"}
                  onChange={handleRadioChangeType}
                  className="h-16 w-16 text-blue-600 bg-gray-100 border-gray-300  "
                />{" "}
                Reduce Shot
              </div>
            </label>
          </div>

          <OrderSaucePicker sauces={sauces} sauce={sauce} onChange={setSauce} />
          {/* additional */}
          <div className="pt-16">
            <span className="text-sm text-primary-onligth font-semibold">
              Additional Request
            </span>
            <div className="flex items-center justify-between">
              <input
                type="text"
                value={inputValueAddition}
                onChange={handleInputChangeAddition}
                maxLength={50}
                placeholder="Please enter text (up to 50 characters)"
                className="block w-full h-32 mt-8 p-1 text-gray-900 border rounded border-gray-300 bg-gray-50 text-xs"
              ></input>
            </div>
          </div>
        </div>
        <footer>
          <button
            type="submit"
            className={`${
              isFormValid
                ? "text-white  bg-[#F86903] "
                : "text-netural-N80 bg-netural-N40"
            } w-full h-48 flex justify-center mx-auto my-8 rounded-lg items-center ${
              isFormValid ? "cursor-pointer" : "cursor-not-allowed"
            }`}
            disabled={!isFormValid}
          >
            Next
          </button>
        </footer>

        <OrderSummaryBar open={showModal} onClose={handleOnClose} />
      </form>
    </div>
  );
};
